import { render } from "./ClaimAppeals.vue?vue&type=template&id=6ca3ed55&scoped=true"
import script from "./ClaimAppeals.vue?vue&type=script&lang=js"
export * from "./ClaimAppeals.vue?vue&type=script&lang=js"

import "./ClaimAppeals.vue?vue&type=style&index=0&id=6ca3ed55&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca3ed55"]])

export default __exports__